import { useQuery } from '@apollo/client';
import { DollarSign, TrendingUp } from 'react-feather';
import { Col, Row } from 'reactstrap';
import { USER_PURCHASES_HISTORY } from '../../../../graphql/Query/users';

export const MonthsComponent = ({ userId }) => {
  const { loading, data } = useQuery(USER_PURCHASES_HISTORY, {
    variables: {
      id: userId
    }
  });

  if (loading) {
    return null;
  }

  const { findUserPurchaseHistoryById: _data } = data;
  return (
    <Row className="mt-2 d-flex gap-sm-1">
      <Col
        sd="6"
        md={4}
        className="d-flex justify-content-between align-items-center "
      >
        <div
          style={{
            background: '#eeedfd',
            padding: '8px',
            borderRadius: 5
          }}
        >
          <DollarSign color="#7367f0" />
        </div>
        <span>
          <div
            style={{
              color: '#6D6B7B',
              fontWeight: 600
            }}
          >
            ${_data.total}
          </div>
          <div
            style={{
              fontSize: 11
            }}
          >
            Premium
          </div>
        </span>
      </Col>
      <Col md={5} className="d-flex justify-content-between align-items-center">
        <div
          style={{
            background: '#e9f9ee',
            padding: '8px',
            borderRadius: 5
          }}
        >
          <TrendingUp color="#32ca75" />
        </div>
        <span>
          <div
            style={{
              color: '#6D6B7B',
              fontWeight: 600
            }}
          >
            {_data.months}
          </div>
          <div
            style={{
              fontSize: 11
            }}
          >
            Meses Premium
          </div>
        </span>
      </Col>
    </Row>
  );
};
